
export const getTextFromDraft = (text: string) => {
    let result = '';
    const element = document.createElement('div');

    element.insertAdjacentHTML('afterbegin', text);

    const processNode = (node: HTMLElement, index: number) => {
        if (node.nodeType === Node.TEXT_NODE) {
            result += node.textContent;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            const tagName = node.tagName.toLowerCase();

            switch (tagName) {
                case 'br':
                    result += '\n';
                    break;
                case 'p':
                case 'div':
                case 'h1':
                case 'h2':
                case 'h3':
                case 'h4':
                case 'h5':
                case 'h6':
                    node.childNodes.forEach(processNode);
                    result += '\n';
                    break;
                case 'ul':
                case 'ol':
                    node.childNodes.forEach(processNode);
                    result += '\n';
                    break;
                case 'li':
                    if ((node.parentNode as HTMLElement).tagName.toLowerCase() === 'ol') {
                        result += `${index + 1}. `; // Prefix ordered list item with position in the list and a dot followed by a space
                    } else {
                        result += '- '; // Prefix list item with dash and space
                    }
                    node.childNodes.forEach(processNode);
                    result += '\n';
                    break;
                default:
                    // Process other elements without adding extra formatting
                    node.childNodes.forEach(processNode);
            }
        }
    };

    processNode(element, 0);

    return result.trim();
};

export const rawStringToHtml = (content: string): string => {
    const element = document.createElement('div');

    element.insertAdjacentHTML('afterbegin', content);

    return element.innerHTML;
};

export const getAsHtml = (editorContent: string, editorState: any) => {
    // tslint:disable-next-line:no-null-keyword
    return !!getTextFromDraft(editorContent) ? rawStringToHtml(editorContent) : null;
};
